;
define("product_views_option_hidden.tpl", function(){});

